// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1phsX","legacyBtn":"MutateMid_legacyBtn__3bP8B"};